import '~/assets/scss/npf-asset-management.scss'

import getSwiperSlider from '~/js/modules/slider';

window.addEventListener(`DOMContentLoaded`, () => {

  const objectsSlider = document.querySelector(`.s-objects__slider`),
    objectsSwiperParams = {
      slidesPerView: 1.1,
      loop: false,
      autoplay: false,
      spaceBetween: 10,
      navigation: {
        nextEl: `.s-objects .slider-arrows__arrow--next`,
        prevEl: `.s-objects .slider-arrows__arrow--prev`,
        disabledClass: `disabled`,
      },
      pagination: false,
      breakpoints: {
        320: {
        },
        480: {
        },
        1024: {
          slidesPerView: 1.7,
          spaceBetween: 25,
        }
      }
    };
  if (objectsSlider) {
    getSwiperSlider(objectsSlider, objectsSwiperParams);
  }

  const npfForm = document.querySelector(`.js-form-npf`);
  if (npfForm) {
    npfForm.addEventListener('submit', function () {
      const sectionForm = document.querySelector('#npf-form');

      let offsetPosition = sectionForm.getBoundingClientRect().top + document.documentElement.scrollTop - 240;
      
      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth"
      });
    })
  }
  const getPresentationButton = document.querySelector('.js-legal-presentation-get');
  const windowPresentation = document.querySelector('.js-legal-presentation-window');
  const closeWindow = document.querySelectorAll('.js-close-presentation')
  if (getPresentationButton) {
    getPresentationButton.addEventListener('click', function (e) {
      if (windowPresentation) {
        windowPresentation.classList.add('active');

        if (closeWindow) {
          closeWindow.forEach((item) => {
            item.addEventListener('click', function (e) {
              windowPresentation.classList.remove('active');
            })
          })
        }
      }
    })
  }
  //так как слайдер перекрывает стандартный якорь
  const pageAnchors = document.querySelectorAll('.js-anchor');
  if (pageAnchors.length) {
    pageAnchors[0].classList.add('active')
    pageAnchors.forEach(anchor => {
      anchor.addEventListener('click', function (e) {
        e.preventDefault();
        const headerOffset = document.querySelector(".header").offsetHeight;
        const hrefDestination = document.querySelector(this.getAttribute('href'));

        let offsetPosition = hrefDestination.getBoundingClientRect().top + document.documentElement.scrollTop - headerOffset;

        window.scrollTo({
          top: offsetPosition,
          behavior: "smooth"
        });
      });
    });
  }

  const imagesGallery = document.querySelectorAll('.js-image-fullscreen');
  const bodyTag = document.querySelector('body');

  if (imagesGallery.length) {
    imagesGallery.forEach(image => {
      image.addEventListener('click', function() {
        image.classList.toggle('is-gallery');
        bodyTag.classList.toggle('no-scroll')
      })
    })
  }

  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
      e.preventDefault();

      document.querySelector(this.getAttribute('href')).scrollIntoView();
    });
  });

  window.addEventListener("scroll", event => {
    let fromTop = window.scrollY;
    const sectionBlock = document.querySelectorAll('.scroll-link');

    sectionBlock.forEach((block, index) => {
      let section = document.querySelector(block.hash);
      let previousSection;
      if (index > 0) {
        previousSection = document.querySelector(sectionBlock[index - 1].hash);
      }
      if (section.offsetTop - 350 <= fromTop) {
        block.classList.add("active");

        if (previousSection) {
          sectionBlock[index - 1].classList.remove("active");
        }
      } else {
        block.classList.remove("active");
      }
    });
  });
});